<div class="cmp-card">
    <div class="cmp-card__header">CMP Progress</div>
    <div class="cmp-card__body">
        <div class="cmp-score-section">
            <div class="cmp-score-header">
                <span class="cmp-score-label">Assessment Score</span>
                <span class="cmp-score-value">{{cyd.currentScore}} / {{cyd.maxScore}}</span>
            </div>
            <div class="cmp-zone-track">
                <div
                    class="cmp-zone cmp-zone--red"
                    [style.width.%]="(cyd.lowCutScore / cyd.maxScore) * 100"
                ></div>
                <div
                    class="cmp-zone cmp-zone--yellow"
                    [style.width.%]="((cyd.highCutScore - cyd.lowCutScore) / cyd.maxScore) * 100"
                ></div>
                <div
                    class="cmp-zone cmp-zone--green"
                    [style.width.%]="((cyd.maxScore - cyd.highCutScore) / cyd.maxScore) * 100"
                ></div>
                <div
                    class="cmp-zone-needle"
                    [style.left.%]="(cyd.currentGraphScore / cyd.maxScore) * 100"
                ></div>
            </div>
            <div class="cmp-zone-legend">
                <span class="cmp-zone-legend__item cmp-zone-legend__item--red">Low</span>
                <span class="cmp-zone-legend__item cmp-zone-legend__item--green">High</span>
            </div>
        </div>
        <div class="cmp-metrics">
            <div class="cmp-metric">
                <span class="cmp-metric__value">{{cyd.ceuDueTotalCount}}</span>
                <span class="cmp-metric__label">CEUs likely due</span>
            </div>
            <div class="cmp-metric">
                <span class="cmp-metric__value">
                    {{cyd.ceuDueOn | amDateFormat: 'MM/DD/YYYY'}}
                </span>
                <span class="cmp-metric__label">Due date</span>
            </div>
        </div>
    </div>
</div>

<div class="cmp-card">
    <div class="cmp-card__header">CRCE Progress</div>
    <div class="cmp-card__body">
        <div
            *ngIf="!credential || !credential.name"
            class="cmp-empty"
        >
            Select a credential type to view CRCE status.
        </div>
        <div *ngIf="credential && credential.name">
            <div class="crce-section">
                <div class="crce-header">
                    <span class="crce-year-badge">{{credential.crceYear}} Assessment</span>
                    <div class="crce-title-row">
                        <span class="crce-title">{{credential.name}}</span>
                        <span
                            class="crce-pct"
                            [ngClass]="barColorClass(crcePercentage)"
                        >
                            {{crcePercentage | number:'1.0-0'}}% Completed
                        </span>
                    </div>
                </div>
                <div class="cmp-track">
                    <div
                        class="cmp-fill"
                        [ngClass]="barColorClass(crcePercentage)"
                        [style.width.%]="crcePercentage"
                    ></div>
                    <div class="cmp-threshold"></div>
                </div>
                <div class="crce-footer">
                    <span>
                        {{credential.questionAnsweredCountForCurrentYearCRCE}} of {{credential.questionCountForCurrentYearCRCE}} completed
                    </span>
                    <span>90% to earn CRCE</span>
                </div>
            </div>
            <div
                class="crce-section"
                *ngIf="credential.crcePreviousYear"
            >
                <div class="crce-header">
                    <span class="crce-year-badge">{{credential.crcePreviousYear}}</span>
                    <div class="crce-title-row">
                        <span class="crce-title">{{credential.name}} Assessment</span>
                        <span
                            class="crce-pct"
                            [ngClass]="barColorClass(crcePercentagePreviousYear)"
                        >
                            {{crcePercentagePreviousYear | number:'1.0-0'}}% Completed
                        </span>
                    </div>
                </div>
                <div class="cmp-track">
                    <div
                        class="cmp-fill"
                        [ngClass]="barColorClass(crcePercentagePreviousYear)"
                        [style.width.%]="crcePercentagePreviousYear"
                    ></div>
                    <div class="cmp-threshold"></div>
                </div>
                <div class="crce-footer">
                    <span>
                        {{credential.questionAnsweredCountForPreviousYearCRCE}} of {{credential.questionCountForPreviousYearCRCE}} completed
                    </span>
                    <span>90% to earn CRCE</span>
                </div>
            </div>
        </div>
    </div>
</div>

<button
    type="button"
    class="button button--alt cmp-report-btn"
    routerLink="/assessment/getemail/{{personId}}"
>
    Send my CMP Assessment Report
</button>
